import type { CategoriaAlteracao, EstadoAplicacao } from "@/modules/recursos/simulacao";

import type { EstadoTag } from "./types-aplicar-simulacao-dialog";

export const APLICAR_TITULO = "Aplicar Simulação";
export const APLICANDO_TITULO = "Aplicando simulação";
export const ROTULO_VOLTAR = "Voltar para simulação";
export const ROTULO_CONCLUIR = "Concluir";
export const ROTULO_RETOMAR = "Retomar";
export const ROTULO_AJUSTAR = "Ajustar na simulação";
export const ROTULO_TENTAR_NOVAMENTE = "Tentar novamente";

export const CATEGORIAS: readonly CategoriaAlteracao[] = ["profissional", "fornecedor", "local"];

/** Tag de status do cartão (Figma 10899:2536, 10899:2542, 10899:2548). */
export const ESTADO_TAG: Record<EstadoAplicacao, Pick<EstadoTag, "icone" | "severity">> = {
  pendente: { icone: "pi pi-clock", severity: "secondary" },
  aplicando: { icone: "pi pi-sync", severity: "info" },
  aplicada: { icone: "pi pi-check", severity: "success" },
  "aplicada-com-aviso": { icone: "pi pi-exclamation-triangle", severity: "warning" },
  "nao-aplicada": { icone: "pi pi-times-circle", severity: "danger" },
  descartada: { icone: "pi pi-ban", severity: "secondary" },
};
